import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home.js';
import CompanyManagement from './components/Home/features/CompanyManagement.js';
import HRMManagement from './components/Home/features/Hrm.js';
import ScrollToTop from './components/ScrollToTop.js';

import { Analytics } from '@vercel/analytics/react';
import CRMManagement from './components/Home/features/Crm.js';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Analytics />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/features/company" element={<CompanyManagement />} />
        <Route path="/features/hrm" element={<HRMManagement />} />
        <Route path="/features/crm" element={<CRMManagement />} />
      </Routes>
    </Router>
  );
}

export default App;
